"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OlympusConference = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var OrOptions_1 = require("../../inputs/OrOptions");
var SelectOption_1 = require("../../inputs/SelectOption");
var ResourceType_1 = require("../../ResourceType");
var CardName_1 = require("../../CardName");
var DeferredAction_1 = require("../../deferredActions/DeferredAction");
var CardRenderer_1 = require("../render/CardRenderer");
var OlympusConference = (function (_super) {
    __extends(OlympusConference, _super);
    function OlympusConference() {
        var _this = _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.OLYMPUS_CONFERENCE,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.EARTH, Tags_1.Tags.BUILDING],
            cost: 10,
            resourceType: ResourceType_1.ResourceType.SCIENCE,
            metadata: {
                cardNumber: '185',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.science().played.colon().science().br;
                    b.or().br;
                    b.minus().science().plus().cards(1);
                }),
                description: 'When you play a Science tag, including this, either add a Science resource to this card, or remove a Science resource from this card to draw a card.',
                victoryPoints: 1,
            },
        }) || this;
        _this.resourceCount = 0;
        return _this;
    }
    OlympusConference.prototype.onCardPlayed = function (player, card) {
        var _this = this;
        var scienceTags = card.tags.filter(function (tag) { return tag === Tags_1.Tags.SCIENCE; }).length;
        for (var i = 0; i < scienceTags; i++) {
            player.game.defer(new DeferredAction_1.DeferredAction(player, function () {
                if (_this.resourceCount === 0) {
                    player.addResourceTo(_this, 1);
                    return undefined;
                }
                return new OrOptions_1.OrOptions(new SelectOption_1.SelectOption('Remove a science resource from this card to draw a card', 'Remove resource', function () {
                    player.removeResourceFrom(_this);
                    player.drawCard();
                    return undefined;
                }), new SelectOption_1.SelectOption('Add a science resource to this card', 'Add resource', function () {
                    player.addResourceTo(_this, 1);
                    return undefined;
                }));
            }), -1);
        }
        return undefined;
    };
    OlympusConference.prototype.play = function () {
        return undefined;
    };
    OlympusConference.prototype.getVictoryPoints = function () {
        return 1;
    };
    return OlympusConference;
}(Card_1.Card));
exports.OlympusConference = OlympusConference;
//# sourceMappingURL=OlympusConference.js.map